import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import SEO from "@/components/SEO";

import Home from "@/pages/Home";
import Learn from "@/pages/Learn";
import Article from "@/pages/Article";
import About from "@/pages/About";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App font-body bg-offwhite text-charcoal">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <SEO />
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/learn" element={<Learn />} />
            <Route path="/learn/:slug" element={<Article />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            {/* Legacy routes redirect to home */}
            <Route path="/services" element={<Navigate to="/" replace />} />
            <Route path="/who-we-help" element={<Navigate to="/" replace />} />
            <Route path="/portfolio" element={<Navigate to="/" replace />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1E2A38",
              color: "#FFFFFF",
              border: "1px solid rgba(199,168,109,0.4)",
              borderRadius: 2,
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
